module.exports = __webpack_public_path__ + "img/en.dc204662.svg";